import { render, staticRenderFns } from "./UpdatePersonalInfoPhoneNumber.vue?vue&type=template&id=70cab028"
import script from "./UpdatePersonalInfoPhoneNumber.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalInfoPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports